// useCreateUser.ts

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addUser } from '../services/apiUsers.ts';
import { toast } from '../utils/sweetAlert.ts';

export function useCreateUser() {
  const queryClient = useQueryClient();

  const { isLoading: isCreatingUser, mutate: createUser } = useMutation({
    mutationFn: (newUser: { firstName: string; lastName: string; email: string; roles: string[] }) =>
      addUser(newUser.firstName, newUser.lastName, newUser.email, newUser.roles),
    onSuccess: () => {
      queryClient.invalidateQueries(['users']);
      toast('success', 'User added successfully!');
    },
    onError: (error: any) => {
      toast('error', `Something went wrong! ${error.message}`);
    },
  });

  return { isCreatingUser, createUser };
}
